import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import RefreshIcon from '@material-ui/icons/Refresh'
import { withStyles } from '@material-ui/core/styles'


const styles = () => ({
  '@keyframes infinite-rotate': {
    from: {
      transform: 'rotate(0deg)',
    },
    to: {
      transform: 'rotate(360deg)',
    },
  },
  root: {
    flex: 1,
    marginTop: 20,
    marginRight: 20,
    width: '100%',
    minWidth: 150,
    maxWidth: 300,
  },
  click: {
    cursor: 'pointer',
  },
  action: {
    '& > svg': {
      fill: 'rgba(0, 0, 0, 0.25)',
    },
  },
  header: {
    height: 50,
  },
  refreshing: {
    animation: '$infinite-rotate 1s linear infinite',
  },
})


const Widget = ({
  classes,
  primary,
  className,
  secondary,
  onRefresh,
  isRefreshing,
}) => {
  return (
    <Card
      onClick={onRefresh}
      className={classNames(classes.root, {
        [classes.click]: !!onRefresh,
      }, className)}
    >
      <CardHeader
        className={classes.header}
        action={<RefreshIcon className={classNames({ [classes.refreshing]: isRefreshing })} />}
        classes={{
          action: classes.action,
        }}
      />

      <CardContent>
        <Typography align="center" variant="h1" color="primary">{primary}</Typography>
        <Typography align="center">{secondary}</Typography>
      </CardContent>
    </Card>
  )
}


Widget.propTypes = {
  primary: PropTypes.any,
  secondary: PropTypes.any,
  onRefresh: PropTypes.func,
  className: PropTypes.string,
  isRefreshing: PropTypes.bool,
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(Widget)
